module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Everybody Needs Love")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#epigraph"
    }
  }, [_vm._v("Epigraph")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-early-years"
    }
  }, [_vm._v("The Early Years")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#the-spooks"
    }
  }, [_vm._v("The Spooks")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#the-5-men-its"
    }
  }, [_vm._v("The 5 Men-Its")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#muscle-shoals-a-guitar-player-for-hire"
    }
  }, [_vm._v("Muscle Shoals: A Guitar Player for Hire")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#the-birth-of-muscle-shoals-sound-studio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Birth of Muscle Shoals Sound Studio")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#mss-open-for-business",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MSS: Open for Business")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#sandra-richburg",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sandra Richburg")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#joe-tex-and-the-staple-singers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1970: Joe Tex and the Staple Singers")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#jim-coleman-and-the-quest-for-perfection",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jim Coleman and the Quest for Perfection")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#an-unforeseen-outcome",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Unforeseen Outcome")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#leaving-muscle-shoals-sound",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leaving Muscle Shoals Sound")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#it-all-goes-wrong",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It All Goes Wrong")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#below-the-radar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Below the Radar")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#nashville-and-beyond",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nashville and Beyond")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#very-extremely-dangerous",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Very Extremely Dangerous")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#the-rocking-horses-and-nighthawks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rocking Horses and Nighthawks")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#down-the-rabbit-hole",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Down the Rabbit Hole")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#letters-from-mississippi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letters from Mississippi")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#in-the-wake-of-letters",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Wake of Letters")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#cry-and-moan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cry and Moan")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#italy-and-a-soul-revival",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Italy and a Soul Revival")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#a-very-blue-highway",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Very Blue Highway")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#permissions-acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Permissions Acknowledgments")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#discography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discography")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#about-the-author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0